import { useEffect } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import Input from "../../components/controls/Input";
import Button from "../../components/controls/Button";
import { useForm, Form } from "../../components/useForm";
import Select from "../../components/controls/Select";
import { DASHBOARD_RATE_DISPLAY } from "../../constants";

const initialFormValues = {
  grade_name: "",
  rate: "",
  dashboard_display: DASHBOARD_RATE_DISPLAY.DISABLED,
  status: 1,
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function DiscountForm({
  materials,
  grades,
  sizes,
  types,
  addOrEdit,
  recordForEdit,
}) {
  const classes = useStyles();
  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };

  // eslint-disable-next-line no-unused-vars
  const {
    values,
    errors,
    setErrors,
    setValues,
    resetForm,
    handleInputChange,
  } = useForm(initialFormValues, true, validate);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      addOrEdit(values, resetForm);
    }
  };

  useEffect(() => {
    if (recordForEdit !== null)
      setValues({
        ...recordForEdit,
      });
  }, [recordForEdit, setValues]);
  const gradeStatus = [
    { id: 1, title: "Active" },
    { id: 0, title: "Inactive" },
  ];
  const dashboardRateDisplayOptions = [
    { id: DASHBOARD_RATE_DISPLAY.ENABLED, title: "Enabled" },
    { id: DASHBOARD_RATE_DISPLAY.DISABLED, title: "Disabled" },
  ];
  return (
    <div className={classes.root}>
      <Form onSubmit={handleFormSubmit}>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <Input
              required
              name="grade_name"
              value={values.grade_name}
              label="Name"
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Input
              required
              name="rate"
              value={values.rate}
              label="Price"
              type='number'
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Select
              name="dashboard_display"
              label="Display Rate on Dashboard"
              value={values.dashboard_display}
              onChange={handleInputChange}
              options={dashboardRateDisplayOptions}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Select
              name="status"
              label="Status"
              value={values.status}
              onChange={handleInputChange}
              options={gradeStatus}
            />
          </Grid>
          <Grid item>
            <Button text="Submit" type="submit" />
            <Button
              text="Reset"
              type="button"
              color="default"
              onClick={resetForm}
            />
          </Grid>
        </Grid>
      </Form>
    </div>
  );
}
